<template>
  <a-config-provider :locale="Locale">
    <a-layout class="cg-layout-warp">
      <!--左边-->
      <a-layout-sider
        v-if="!IsSubsys"
        class="cg-layout-sider"
        v-model="Collapsed"
        collapsible
        :trigger="null"
      >
        <div class="cg-layout-sider-content">
          <!--logo-->
          <div class="cg-layout-logo">
            <slot name="logo">
              <!-- <img class="default-logo" src='images/logo.png' /> -->
            </slot>
          </div>
          <!--菜单-->
          <div class="cg-layout-menu cg-auto-scroll">
            <cg-menu
              v-model="SelectMenuKeys"
              :dataList="menuDataList"
              :msgCountStyle="menuMsgCountStyle"
              @select="OnMenuSelect"
              @click="OnMenuClick"
            />
          </div>
        </div>
      </a-layout-sider>

      <!--右边-->
      <a-layout>
        <!--头部-->
        <a-layout-header v-if="!IsSubsys" class="cg-layout-header">
          <div class="cg-layout-header-left">
            <a-button
              class="menu-fold-btn"
              type="link"
              :icon="Collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="Collapsed = !Collapsed"
            >
            </a-button>
          </div>
          <div class="cg-layout-header-right">
            <slot name="headerContent"></slot>
          </div>
        </a-layout-header>
        <!--主要内容-->
        <a-layout-content class="cg-layout-content">
          <slot></slot>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-config-provider>
</template>
<script>
import CgMenu from "../Menu";
import { mapState } from "vuex";

export default {
  components: { CgMenu },
  props: {
    menuDataList: {
      type: Array,
      default: () => [],
    },
    selectMenuKeys: {
      type: Array,
      default: () => [],
    },
    menuMsgCountStyle: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      Collapsed: false,
      SelectMenuKeys: []
    };
  },
  computed: {
    ...mapState(["IsSubsys"]),
    Locale() {
      return this.$store.state.Locale;
    },
  },
  watch: {
    selectMenuKeys() {
      this.SelectMenuKeys = this.selectMenuKeys;
    },
  },
  mounted() {},
  methods: {
    OnMenuSelect({ item, key, selectedKeys }) {
      this.$emit("menuSelect", { item, key, selectedKeys });
    },
    OnMenuClick({ item, key, keyPath }) {
      this.$emit("menuClick", { item, key, keyPath });
    },
  },
};
</script>
<style>
.cg-layout-warp {
  height: 100%;
}

.cg-layout-warp .cg-layout-header {
  background: rgb(255, 255, 255);
  padding: 0px;
  -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  z-index: 1;
  display: flex;
}

.cg-layout-warp .cg-layout-header-right {
  flex: 1;
}

.cg-layout-warp .menu-fold-btn {
  font-size: 18px;
  color: inherit;
  padding: 0 24px;
}

.cg-layout-warp .cg-layout-sider {
  flex: 0 0 256px !important;
  max-width: 256px !important;
  min-width: 256px !important;
  width: 256px !important;
}
.cg-layout-warp .cg-layout-sider.ant-layout-sider-collapsed {
  flex: 0 0 80px !important;
  max-width: 80px !important;
  min-width: 80px !important;
  width: 80px !important;
}

.cg-layout-warp .cg-layout-sider-content {
  height: 100%;
  display: flex;
  flex: auto;
  flex-direction: column;
}

.cg-layout-warp .cg-layout-logo {
  height: 32px;
  margin: 16px;
  flex: 0 0 auto;
}

.cg-layout-warp .cg-layout-logo .default-logo {
  width: 60%;
  margin-left: 8px;
}

.cg-layout-warp .cg-layout-menu {
  height: 100%;
  overflow: auto;
}
</style>
